import { TranslateResources } from './translateCodes';

const translation: Partial<TranslateResources> = {
    MINS: 'Phút',
    YOUR_EMAIL: 'Email',
    PHONE: 'Số điện thoại',
    CONTINUE: 'tiếp tục',
    TRANSACTION_DETAILS: 'Chi tiết giao dịch',
    CLIENT_NAME: 'Tên khách hàng',
    PHONE_NUMBER: 'Số điện thoại',
    PAYMENT_TYPE: 'Hình thức thanh toán',
    SALE_ID: 'Mã hóa đơn',
    DESCRIPTION: 'Mô tả',
    PRICE: 'Giá',
    SERVICE: 'Dịch vụ',
    PRODUCT: 'Sản phẩm',
    SUB_TOTAL: 'Tạm tính',
    DISCOUNT: 'Giảm giá',
    TAX: 'Thuế',
    TIP: 'Tiền tip',
    TOTAL_AMOUNT: 'Tổng cộng',
    RATE_EXPERIENCE: 'Vui lòng đánh giá trải nghiệm của bạn với',
    GIVE_FEEDBACK: 'Gửi phản hồi',
    ENTER_FEEDBACK: 'Nhập phản hồi của bạn',
    SUBMIT: 'Gửi',
    VIEW_TRANSACTION_DETAILS: 'Xem chi tiết giao dịch',
    WE_LOVE_FEEDBACK: 'Chúng tôi rất mong nhận được phản hồi từ bạn!',
    SHARE_EXPERIENCE_GOOGLE: 'Chia sẻ trải nghiệm của bạn trên Google để giúp người khác biết đến dịch vụ của chúng tôi.',
    CLICK_TO_REVIEW: 'Nhấn để đánh giá!',
    REVIEW_EXISTS: 'Đánh giá đã tồn tại',
    SALE_REVIEWED: 'Giao dịch đã được đánh giá',
    THANK_FOR_FEEDBACK: 'Cảm ơn bạn đã chia sẻ phản hồi!',
    FEEDBACK_RECEIVED: 'Chúng tôi đã nhận được phản hồi của bạn và trân trọng đóng góp của bạn trong việc cải thiện dịch vụ.',

};

export const vi = {
    translation
};